import { AddressElement, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useMemo } from "react";
import { DEFAULT_COUNTRY_CODE, DEFAULT_STATE_CODE } from "../../../constants/constants";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "");

type BillingAddressStripeElementProps = {
  defaultAddress?: {
    firstName?: string;
    lastName?: string;
    line1?: string;
    line2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
  } | null;
  onAddressChange: (payload: {
    complete: boolean;
    address: {
      firstName?: string;
      lastName?: string;
      line1?: string;
      line2?: string;
      city?: string;
      state?: string;
      postalCode?: string;
      country?: string;
    };
  }) => void;
};

const BillingAddressStripeElement = ({
  defaultAddress,
  onAddressChange,
}: BillingAddressStripeElementProps) => {
  const defaultFullName = [defaultAddress?.firstName, defaultAddress?.lastName]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .join(" ");
  const elementsOptions = useMemo(
    () => ({
      mode: "payment" as const,
      amount: 100,
      currency: "usd",
      appearance: {
        theme: "stripe" as const,
      },
    }),
    []
  );

  return (
    <Elements stripe={stripePromise} options={elementsOptions}>
      <AddressElement
        options={{
          mode: "billing",
          allowedCountries: ["US"],
          autocomplete: {
            mode: "automatic",
          },
          defaultValues: defaultAddress
            ? {
              name: defaultFullName || undefined,
              address: {
                line1: defaultAddress.line1 || "",
                line2: defaultAddress.line2 || "",
                city: defaultAddress.city || "",
                state: DEFAULT_STATE_CODE,
                postal_code: defaultAddress.postalCode || "",
                country: DEFAULT_COUNTRY_CODE,
              },
            }
            : undefined,
        }}
        onChange={(event: any) => {
          const address = event?.value?.address || {};
          const rawName = String(event?.value?.name || "").trim();
          const splitName = rawName ? rawName.split(/\s+/) : [];
          const firstName = splitName.length > 0 ? splitName[0] : "";
          const lastName = splitName.length > 1 ? splitName.slice(1).join(" ") : "";
          onAddressChange({
            complete: !!event?.complete,
            address: {
              firstName,
              lastName,
              line1: address.line1 || "",
              line2: address.line2 || "",
              city: address.city || "",
              state: address.state || "", 
              postalCode: address.postal_code || "",
              country: address.country || "",
            },
          });
        }}
      />

    </Elements>
  );
};

export default BillingAddressStripeElement;
